"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _filesystemUploadDirectory = _interopRequireDefault(require("./filesystem-upload-directory"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FileSystemUploadAsset = /*#__PURE__*/function (_FileSystemUploadDire) {
  _inherits(FileSystemUploadAsset, _FileSystemUploadDire);

  var _super = _createSuper(FileSystemUploadAsset);

  /**
   * Constructs a new instance of the class using the given values.
   * @param {FileSystemUploadOptions} uploadOptions URL of the options
   *  will be used to build the asset's remote path.
   * @param {string} localPath Full path to the local asset.
   * @param {string} remoteNodeName Name of the asset's node as it should
   *  appear in AEM.
   * @param {number} size Size, in bytes, of the asset.
   * @param {FileSystemUploadDirectory} [directory] If provided, the
   *  directory to which the asset belongs. If not provided then the
   *  asset will be treated as the root.
   */
  function FileSystemUploadAsset(uploadOptions, localPath, remoteNodeName, size, directory) {
    var _this;

    _classCallCheck(this, FileSystemUploadAsset);

    _this = _super.call(this, uploadOptions, localPath, remoteNodeName, directory);
    _this.size = size;
    return _this;
  }
  /**
   * Retrieves the size of the asset, as provided in the constructor.
   * @returns {number} Size in bytes.
   */


  _createClass(FileSystemUploadAsset, [{
    key: "getSize",
    value: function getSize() {
      return this.size;
    }
  }]);

  return FileSystemUploadAsset;
}(_filesystemUploadDirectory.default);

exports.default = FileSystemUploadAsset;